// prettier-ignore
export const  UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path fill="#B7B8C1" fillRule="evenodd" d="M.83 10a9.17 9.17 0 1 1 18.34 0A9.17 9.17 0 0 1 .83 10ZM10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z" clipRule="evenodd"/>
    <path fill="#B7B8C1" fillRule="evenodd" d="M7.08 7.5a2.92 2.92 0 1 1 5.84 0 2.92 2.92 0 0 1-5.84 0ZM10 6.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-1.67 6.67a3.33 3.33 0 0 0-3.32 3.1.83.83 0 1 1-1.67-.1 5 5 0 0 1 5-4.67h3.33a5 5 0 0 1 4.99 4.66.83.83 0 0 1-1.67.11 3.33 3.33 0 0 0-3.32-3.1H8.33Z" clipRule="evenodd"/>
  </svg>
)
